import React, { createContext, useContext, useEffect, useState } from "react";
import LOCALES from "../locales";

const Ctx = createContext({ lang: "ar", t: (k) => k, setLang: () => {}, dir: "rtl" });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("app_lang") || "ar");
  const dict = LOCALES[lang] || LOCALES.ar;
  const dir = dict.dir;

  const setLang = (l) => {
    if (!LOCALES[l]) return;
    localStorage.setItem("app_lang", l);
    setLangState(l);
  };

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
  }, [lang, dir]);

  const t = (key) => dict[key] || LOCALES.ar[key] || key;

  return <Ctx.Provider value={{ lang, setLang, t, dir, locales: Object.keys(LOCALES), localeName: (l) => LOCALES[l]?.name || l }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
